import axiosInstance from "../../utils/axiosInstance";

const authService = {

    login: async (data) => {

        const response = await axiosInstance.post(
            "/Auth/login",
            data
        );

        return response.data;
    },

    changePassword: async (data) => {

        const response = await axiosInstance.post(
            "/Auth/change-password",
            data
        );

        return response.data;
    }

};

export default authService;